import {fetch} from "utils/dataAccess";

/**
 * How many invoice documents of a retailer are still being generated: a document is inserted in
 * "new" and the worker walks it to "generated", so anything short of that is still in flight.
 *
 * @param {string} retailerId uuid of the retailer
 *
 * @return {Promise<{pending: number, inProgress: boolean}>}
 */
export default function invoiceGenerationStatus(retailerId) {
    return fetch(`/retailers/${retailerId}/invoice_generation_status`, {signal: null}, false, true)
        .then(response => response.json());
}
